import {NgModule} from '@angular/core';

import {MzInjectionService} from './injection.service';

@NgModule({
  providers: [MzInjectionService],
})
export class MzInjectionModule {
}
